module.exports = __webpack_public_path__ + "img/6.a91ee540.png";